import React, { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import LiveExam from '../../../../Services/liveexam.services';
import { ExamData, ResponsesData, SelectedQuestion } from '../context';
import { defaultTheme, NxButton, NxIcon } from '../../../../components/nx';

const t = defaultTheme;

interface IExamFooter {
    handleMarkedForReviewChange: any;
    onSaveClicked: any;
    defaultMarkforReviewState: boolean;
    reloadUserAnswers: any;
}

export default function ExamFooter(props: IExamFooter) {
    const [markReview, setMarkReview] = useState(false);
    const { selectedQuestionId, setSelectedQuestionId } = useContext<any>(SelectedQuestion);
    const { responsesData } = useContext<any>(ResponsesData);
    const [currentSectionQuestions, setCurrentSectionQuestions] = useState<any[]>([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

    const nextQuestion = () => {
        if (currentSectionQuestions.length <= currentQuestionIndex + 1) {
            const sections = responsesData?.questionArr;
            const currentSectionIdx = sections?.findIndex((s: any) => s.section === selectedQuestionId?.section);
            if (sections && currentSectionIdx != null && currentSectionIdx < sections.length - 1) {
                const nextSection = sections[currentSectionIdx + 1];
                const toastId = toast.loading("Switching to next section...");
                setTimeout(() => {
                    toast.dismiss(toastId);
                    setSelectedQuestionId({ section: nextSection.section, question: nextSection.questions[0] });
                    toast.success("Moved to next section.");
                }, 2000);
                return;
            }
            toast("You are on the last question.", { icon: '⚠️' });
            return;
        }
        setSelectedQuestionId({ ...selectedQuestionId, question: currentSectionQuestions[currentQuestionIndex + 1] });
    };

    const handleSaveClicked = async () => {
        const saved = await props.onSaveClicked();
        if (saved) nextQuestion();
    };

    useEffect(() => {
        props.handleMarkedForReviewChange(markReview);
    }, [markReview]);

    const previousQuestion = () => {
        if (currentQuestionIndex === 0) {
            const sections = responsesData?.questionArr;
            const currentSectionIdx = sections?.findIndex((s: any) => s.section === selectedQuestionId?.section);
            if (sections && currentSectionIdx != null && currentSectionIdx > 0) {
                const prevSection = sections[currentSectionIdx - 1];
                const lastQ = prevSection.questions[prevSection.questions.length - 1];
                const toastId = toast.loading("Switching to previous section...");
                setTimeout(() => {
                    toast.dismiss(toastId);
                    setSelectedQuestionId({ section: prevSection.section, question: lastQ });
                    toast.success("Moved to previous section.");
                }, 2000);
                return;
            }
            toast("You are on the first question.", { icon: '⚠️' });
            return;
        }
        setSelectedQuestionId({ ...selectedQuestionId, question: currentSectionQuestions[currentQuestionIndex - 1] });
    };

    useEffect(() => {
        setMarkReview(props.defaultMarkforReviewState);
    }, [props.defaultMarkforReviewState]);

    const clearResponse = async () => {
        try {
            const res = await LiveExam.clearResponse(selectedQuestionId.question);
            if (res.status === 200) props.reloadUserAnswers();
        } catch (e) {}
    };

    useEffect(() => {
        const sectionData = responsesData?.questionArr?.find((res: any) => res.section === selectedQuestionId?.section);
        if (sectionData) {
            setCurrentSectionQuestions(sectionData.questions);
            setCurrentQuestionIndex(sectionData.questions.findIndex((data: any) => data === selectedQuestionId?.question));
        }
    }, [responsesData, selectedQuestionId]);

    return (
        <div style={{
            position: 'sticky', bottom: 0,
            borderTop: `1px solid ${t.border}`, background: t.surface,
            padding: '14px 40px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            fontFamily: '"Geist", ui-sans-serif, system-ui, -apple-system, sans-serif',
        }}>
            <label
                style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: t.inkSoft, cursor: 'pointer' }}
                onClick={() => setMarkReview(!markReview)}
            >
                <span style={{
                    width: 16, height: 16, borderRadius: 4,
                    border: `1px solid ${markReview ? t.warning : t.borderStrong}`,
                    background: markReview ? t.warning : 'transparent',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    {markReview && NxIcon.flag('#fff')}
                </span>
                Mark this question for review
            </label>

            <div style={{ display: 'flex', gap: 10 }}>
                <NxButton t={t} kind="secondary" icon={NxIcon.arrowLeft(t.ink)} onClick={previousQuestion}>
                    Previous
                </NxButton>
                <NxButton t={t} kind="ghost" onClick={clearResponse}>
                    Clear answer
                </NxButton>
                <NxButton t={t} kind="primary" icon={NxIcon.arrowRight('#fff')} onClick={handleSaveClicked}>
                    Save &amp; next
                </NxButton>
            </div>
        </div>
    );
}
